<div #cameraViewContainer id="camera-view-container" class="camera-view-container"></div>